<ng-template #modalContent>
  <div class="dg">
    <div class="row page-header">
      <div class="title-header d-flex align-items-center">
        <div class="vessel-icon"></div>
        {{ label.header | translate}}
      </div>
    </div>
    <form [formGroup]="form">
      <div class="row content">
        <div class="form-group col-md-4">
          <label class="required">{{label.code1 | translate}}</label>
          <ng-select
            notFoundText="{{'No items found' | translate}}"
            [items]="polLocodes"
            bindLabel="code"
            bindValue="code"
            placeholder="{{label.code1 | translate}}"
            formControlName="code1"
            (search)="onNextPortSearch($event, 'polLocodes')"
            (clear)="getLocodes(locodesDefaultParams, 'polLocodes', false)"
            [virtualScroll]="true"
            (scrollToEnd)="onNextPortScrollToEnd('polLocodes')"
            (change)="onValueChanged('name1', 'country1', $event)"
            [ngClass]="{ 'is-invalid': (code1.touched || code1.dirty) && code1.invalid }"
          >
          </ng-select>
        </div>
        <div class="form-group col-md-4">
          <label class="required">{{label.name1 | translate}}</label>
          <div class="text-value f-input">{{ name1.value }}</div>
        </div>
        <div class="form-group col-md-4">
          <label class="required">{{label.country1 | translate}}</label>
          <div class="text-value f-input">{{ country1.value }}</div>
        </div>
        <div class="form-group col-md-4">
          <label class="required">{{label.code2| translate}}</label>
          <ng-select
            notFoundText="{{'No items found' | translate}}"
            [items]="podLocodes"
            bindLabel="code"
            bindValue="code"
            placeholder="{{label.code2 | translate}}"
            formControlName="code2"
            (search)="onNextPortSearch($event, 'podLocodes')"
            (clear)="getLocodes(locodesDefaultParams, 'podLocodes', false)"
            [virtualScroll]="true"
            (scrollToEnd)="onNextPortScrollToEnd('podLocodes')"
            (change)="onValueChanged('name2', 'country2', $event)"
            [ngClass]="{ 'is-invalid': (code2.touched || code2.dirty) && code2.invalid }"
          >
          </ng-select>
        </div>
        <div class="form-group col-md-4">
          <label class="required">{{label.name2 | translate}}</label>
          <div class="text-value f-input">{{ name2.value }}</div>
        </div>
        <div class="form-group col-md-4">
          <label class="required">{{label.country2 | translate}}</label>
          <div class="text-value f-input">{{ country2.value }}</div>
        </div>
        <div class="col-md-12">
          <div class="btn-group text-right">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="onCancel()"
            >{{'Cancel' | translate}}</button>
            <button
              type="button"
              class="btn btn-primary btn-save"
              (click)="onSave()"
              [disabled]="form.invalid"
            >
              {{'Save' | translate}}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
